import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ProductService } from 'src/app/service/product.service';
import { Product } from 'src/app/types/types';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { getPassword, setPassword } from '../../localStorage/storage';

@Component({
  selector: 'app-admin-products',
  templateUrl: './admin-products.component.html',
  styleUrls: ['./admin-products.component.css']
})
export class AdminProductsComponent implements OnInit {

  isLogged : boolean = getPassword() === environment.password;
  products : Product[];
  formControl : FormControl = new FormControl("");
  constructor(
    private productService :ProductService
  ) { 
    this.loadProducts();
    }

  ngOnInit(): void {
  }

  loadProducts = () => {
    this.productService.getAllProducts().subscribe((res: Product[]) => {
      this.products = res;
    });
  }

  login() {
    if(this.formControl.value === environment.password) {
      this.isLogged = true;
      setPassword(this.formControl.value);
    }
    else {
      Swal.fire({
        title:"Contraseña incorrecta",
        icon:"error"
      })
    }
  }

  deleteProduct(product:Product) {
    this.productService.delete(product).subscribe((res: Product) => {
      this.productService.getAllProducts().subscribe((res: Product[]) => {
        this.products = res;
      });
      Swal.fire({
        title: product.name + " eliminado!",
        icon:'success'
      })
    });
  }

  openDialog(product:Product) {
    Swal.fire({
      title: "Estas segur@ que querés eliminar " + product.name + "?",
      icon:'question',
      cancelButtonText:"Mejor no...",
      showCancelButton:true,
    }).then( res => {
      if(res.isConfirmed)
        this.deleteProduct(product)
    })
  }

}
